import { useEffect } from 'react';
import { initEventLogger } from './eventLogger';

export const useShouldRecord = (enabled: boolean) => {
  useEffect(() => {
    initEventLogger(enabled);
  }, [enabled]);

  return enabled;
};